import { z } from 'zod';
import { requiredUuidString } from '../../zod-helpers/index.js';
import { failedDeliveryReasonSchema } from './delivery-change-reason-schema.js';
// notifyContact is stored for a later notification; this epic sends nothing (RS-2).
export const recordSalesOrderFailedDeliveryInputSchema = z.object({
    salesOrderId: requiredUuidString('Sales order is required.', 'Invalid sales order selection.'),
    reason: failedDeliveryReasonSchema,
    notifyContact: z.boolean().nullish(),
});
//# sourceMappingURL=failed-delivery-input.js.map